import React from 'react';
let ccconfig = require('../../cc-config.json');
const ContactPage = () => (React.createElement("article", null,
    React.createElement("section", { className: "main-col" },
        React.createElement("h1", { className: "h2" }, "Contact"),
        React.createElement("p", null, " Colouring Cities has been designed as a sustainable, low-cost model for knowledge exchange/open data platforms able to be reproduced by other towns and cities using our open platform code."),
        React.createElement("p", null, " It is being developed by a small, dedicated team at The Alan Turing Institute. We are unable to answer individual queries but welcome constructive comments on how to improve the site, and on other types of data and new features you might like to see."),
        React.createElement("p", null,
            " You can send us comments or ask questions on our discussion threads at ",
            React.createElement("a", { href: "https://discuss.colouring.london/" }, "https://discuss.colouring.london/"),
            "."),
        React.createElement("p", null,
            " Or on our GitHub page at ",
            React.createElement("a", { href: ccconfig.githubURL + "/discussions" }, ccconfig.githubURL + "/discussions"),
            "."),
        React.createElement("p", null,
            " To view our technical site and platform code please visit Github at: ",
            React.createElement("a", { href: ccconfig.githubURL }, ccconfig.githubURL),
            "."),
        React.createElement("p", null,
            "For press enquiries please contact ",
            React.createElement("a", { href: "https://www.turing.ac.uk/contact-us/press-office" }, "The Alan Turing Institute press office"),
            "."),
        React.createElement("p", null, "If you capture images from the maps on Colouring Cities, please credit our contributors (who collected the data) and Ordnance Survey (who provided the basemaps and building geometries) as follows:"),
        React.createElement("p", null,
            React.createElement("code", null, "Colouring Cities - Building attribute data is \u00A9 Colouring Cities contributors. Maps contain OS data \u00A9 Crown copyright: OS Maps baselayers and building outlines.")),
        React.createElement("hr", null),
        React.createElement("p", null,
            React.createElement("img", { className: "d-block mx-auto", src: "images/logo-cc.jpg" })))));
export default ContactPage;
